import React, {useState} from "react";
import {DiscordRoleData} from "../../data/discord/DiscordRoleData";
import {LoadingContent} from "../LoadingContent";
import useApiCall from "../../hooks/CancellableApiCall";
import {DivisionRoles} from "../../data/DivisionRoles";
import {Accordion, AccordionDetails, AccordionSummary, Divider, Stack, Typography} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {divisionIdentifierToDisplayName} from "../../utils";
import {DiscordRoleLinkDialog} from "./DiscordRoleLinkDialog";

interface DiscordRoePanelContentProps {
    discordRoles: DiscordRoleData[]
    divisionRoles: { [division: string]: DivisionRoles[] }
}

interface DiscordRolePanelInnerRoleContentProps {
    role: DivisionRoles
    discordRoles: DiscordRoleData[]
}

const DiscordRolePanelInnerRoleContent = (props: DiscordRolePanelInnerRoleContentProps) => {
    // eslint-disable-next-line
    const [panelOpen, setPanelOpen] = useState(false)

    return <Stack spacing={2} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
        <Typography>{props.role.displayName}</Typography>
        <DiscordRoleLinkDialog divisionRole={props.role} open={panelOpen} roles={props.discordRoles}/>
    </Stack>
}

const DiscordRolePanelContent = (props: DiscordRoePanelContentProps) => {
    return <>
        {Object.entries(props.divisionRoles).map(([division, divisionRoles]) => {
            return <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`${division}-content`}
                    id={`${division}-header`}
                >
                    <Typography component="span">{divisionIdentifierToDisplayName(division)}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={2}>
                        {divisionRoles && divisionRoles.map((role, idx) => {
                            return <>
                                <DiscordRolePanelInnerRoleContent discordRoles={props.discordRoles} role={role} key={idx} />
                                <Divider />
                            </>
                        })}
                    </Stack>
                </AccordionDetails>
            </Accordion>
        })}
    </>
}

export const DiscordRolePanel = () => {
    const discordRoles = useApiCall<DiscordRoleData[]>({
        url: "/api/discord/roles"
    })

    const divisionRoles  = useApiCall<{ [division: string]: DivisionRoles[] }>({
        initialUrl: `/api/division/list-all-roles`
    })

    return (<LoadingContent showLoadingSkeleton={true} isLoading={
        discordRoles.isLoading || !discordRoles.data ||
        divisionRoles.isLoading || !divisionRoles.data
    }>
        <DiscordRolePanelContent discordRoles={discordRoles.data!!} divisionRoles={divisionRoles.data!!} />
    </LoadingContent>)
}